import { NavigationBar } from '@everlywell/consumer-ui';
import { Link } from 'gatsby';
import React from 'react';

import { resultsURL, secureURL, wwwURL } from '../../utils/consts';
import useNavigation from '../../utils/hooks/useNavigation';
import { NavigationTracking } from './NavigationBar.tracking';
import {
  transformMenuDrawer,
  transformMobileDrawerLinks,
} from './transformations';

export type NavigationBarV2Props = {};

/**
 * NavigationBarV2 component that fetches navigation data from Contentful
 * and renders it using the NavigationBar component from consumer-ui
 */
export default function NavigationBarV2(props: NavigationBarV2Props) {
  const { navigation } = useNavigation();

  if (!navigation?.topLevelMenuItems || !navigation?.topLevelMenuItems?.[0]) {
    return null;
  }

  const mainCategoryLabel = navigation.topLevelMenuItems[0].label;

  // Transform Contentful data to match NavigationBar's expected props
  const categories = navigation.topLevelMenuItems.flatMap(
    (item) => item?.menuDrawers?.map(transformMenuDrawer) || [],
  );

  const mobileBottomButtons = transformMobileDrawerLinks(
    navigation?.topLevelMenuItems[0]?.menuDrawers || [],
  );

  const onCartClick = () => {
    NavigationTracking.trackOpenCart();
    window.location.href = wwwURL;
  };

  return (
    <NavigationBar
      categories={categories}
      profileUrl={`${secureURL}/login`}
      registrationUrl={`${resultsURL}/register`}
      shopAllProductsUrl={`${wwwURL}/products`}
      logoLink="/"
      linkComponent={Link}
      numberOfCartItems={0}
      mainCategoryLabel={mainCategoryLabel || 'Menu'}
      mobileBottomButtons={mobileBottomButtons}
      onCartClick={onCartClick}
      onSearchClick={NavigationTracking.trackOpenSearch}
      onLinkClick={NavigationTracking.trackLinkClick}
      onCategoryOpen={NavigationTracking.trackOpenCategory}
      onRegisterKitClick={NavigationTracking.trackRegisterKitClick}
      onMobileMenuOpen={NavigationTracking.trackMobileMenuOpen}
      onBackToMainMenu={NavigationTracking.trackBackToMainMenu}
      onProfileClick={NavigationTracking.trackOnProfileClick}
      onSearchCallback={NavigationTracking.trackSearchCallback}
      onLogoClick={NavigationTracking.trackLogoClick}
      onShopAllProductsClick={NavigationTracking.trackShopAllProductsClick}
    />
  );
}
